import { MessageModel } from '@/models/message.model'
import { SendMessageOfficialAPIResponse } from '@/redux/message/sagas/createMessageSaga/http/message/types'

export function buildOfficialMessage(message: MessageModel, sendMessageOfficial: SendMessageOfficialAPIResponse) {
  const sendedMessages: MessageModel[] = sendMessageOfficial.messageContent
    .map(messageC => {
      return {
        ...message,
        messageId: messageC.messageId,
        status: sendMessageOfficial.status,
        messageText: messageC.message || '',
        moment: messageC.moment,
        momment: messageC.moment,
        createdAt: messageC.moment || new Date().getTime(),
        audio: messageC?.type === 'audio' ? { audioUrl: messageC.fileUrl, mimeType: messageC.mimeType } : null,
        image:
          messageC?.type === 'image'
            ? {
                mimeType: messageC.mimeType || '',
                imageUrl: messageC.fileUrl || '',
                caption: messageC.caption || ''
              }
            : null,
        video: messageC?.type === 'video' ? { videoUrl: messageC.fileUrl, mimeType: messageC.mimeType } : null,
        document:
          messageC?.type === 'document'
            ? { documentUrl: messageC.fileUrl, mimeType: messageC.mimeType, fileName: messageC?.fileName }
            : null,
        file: '' as any,
        files: null
      }
    })
    .sort((a, b) => b.momment - a.momment)

  return sendedMessages
}
